export const languages = {
  SPANISH: 1,
  CATALAN: 2,
  ENGLISH: 3,
  PORTUGUESE: 4,
  SPANISH_MX: 5
}
